/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../../Core/Components/CustomTable";
import { FinanceHoverIcon } from "../../../Common/Svgs/FinanceIcon";
import { getTableContainerHeight } from "../../../Utils/getTableContainerHeight";
import { getUserByEmail } from "../../../Redux/APIs/systemUsersAPI";
import EnergyListHeader from "./EnergyListHeader";
import { columns } from "./constants";
import DeleteEnergyModal from "./DeleteEnergyModal";
import { updateRates } from "../../../Redux/Slices/rates.slice";
import useDebounce from "../../../Core/hooks/useDebounce";
import {
  getAllBatteryEnergyRates,
  getBatteryEnergyRateList,
} from "../../../Redux/APIs/ratesAPI";
import CustomPagination from "../../../Core/Components/CustomPagination";

const LOCAL_DEFAULT_LIMIT = 10;

const EnergyList = () => {
  const dispatch = useDispatch();

  const { userDetails } = useSelector((state) => state.loggedInUser);

  const { batteryEnergyRateList, deleteEnergyRateModal } = useSelector(
    (state) => state.rates,
  );

  const tableContainerRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    hub: [],
    batteryType: [],
    operationType: [],
  });

  const debounceSearch = useDebounce(search, 500);

  // fetch the battery energy rates along with the filters
  useEffect(() => {
    const filterObj = {
      limit: LOCAL_DEFAULT_LIMIT,
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;

    if (filters.hub.length) {
      filterObj.hubs = filters.hub;
    }
    if (filters.batteryType.length) {
      filterObj.batteryType = filters.batteryType;
    }
    if (filters.operationType.length) {
      filterObj.operationType = filters.operationType;
    }

    dispatch(getBatteryEnergyRateList(filterObj));
  }, [dispatch, currentPage, debounceSearch, filters]);

  // fetch user details and all the locations (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
    dispatch(getAllBatteryEnergyRates());
  }, [dispatch]);

  return (
    <div>
      <div>
        <EnergyListHeader
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
        />

        <div
          className={`h-[calc(100vh-72px-71px-69px-40px)] ${
            batteryEnergyRateList?.result?.length && "overflow-y-scroll"
          }`}
          ref={tableContainerRef}
        >
          <CustomTable
            disableScroll
            columns={columns}
            data={batteryEnergyRateList.result}
            emptyState={
              <FinanceHoverIcon size={16} className="text-dark-grey-text" />
            }
            emptyStateHeight={getTableContainerHeight(tableContainerRef)}
            rowClassName="group"
            pagination={{
              pageSize: LOCAL_DEFAULT_LIMIT,
              total: batteryEnergyRateList?.totalRecords,
              showSizeChanger: false,
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                return (
                  <CustomPagination
                    type={type}
                    current={current}
                    originalElement={originalElement}
                    totalRecords={Number(
                      batteryEnergyRateList?.totalRecords || 0,
                    )}
                  />
                );
              },
              // itemRender: (current, type, originalElement) => {
              //   const lastPage = batteryEnergyRateList.totalRecords / current;

              //   if (type === "prev" && current === 0) {
              //     return (
              //       <button
              //         type="button"
              //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //         style={{
              //           pointerEvents: "none",
              //         }}
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "prev" && current > 0) {
              //     return (
              //       <button
              //         type="button"
              //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "next" && lastPage <= 10) {
              //     return (
              //       <button
              //         type="button"
              //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //         style={{ pointerEvents: "none" }}
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "next") {
              //     return (
              //       <button
              //         type="button"
              //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   return originalElement;
              // },
            }}
          />
        </div>
      </div>

      <DeleteEnergyModal
        visible={deleteEnergyRateModal}
        onCancel={() =>
          dispatch(updateRates({ key: "deleteEnergyRateModal", value: false }))
        }
      />
    </div>
  );
};

export default EnergyList;
